// AddBlockToggle.tsx
import { useState } from "react";
import { Box, VStack, HStack, Text, Icon, Button } from "@chakra-ui/react";
import { FaPlus, FaBullhorn, FaRegImage } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { BlockType } from "@common/interfaces/KYDCampaign";

interface AddBlockToggleProps {
  onAddBlock: (type: BlockType) => void;
  isDisabled?: boolean;
}

const AddBlockToggle = ({ onAddBlock, isDisabled }: AddBlockToggleProps) => {
  const [showMenu, setShowMenu] = useState(false);

  const add = (type: BlockType) => {
    onAddBlock(type);
    setShowMenu(false);
  };

  return (
    <>
      <Button
        variant="link"
        position="fixed"
        bottom={4}
        bg="#111111"
        color="white"
        py={4}
        px={6}
        zIndex={1001}
        borderRadius="40px"
        fontSize="13px"
        leftIcon={<FaPlus />}
        onClick={() => setShowMenu((v) => !v)}
        isDisabled={isDisabled}
      >
        Add Block
      </Button>

      {showMenu && (
        <Box
          position="fixed"
          bottom="80px"
          bg="#111111"
          borderRadius="20px"
          borderEndEndRadius={"50px"}
          p={4}
          w="200px"
          color="white"
          zIndex={1000}
        >
          <VStack align="start" spacing={3}>
            <HStack spacing={2}>
              <Icon as={FiMenu} boxSize={4} color="#FFF8" />
              <Text fontSize="xs" color="#FFF8" fontWeight="bold">
                TEXT
              </Text>
            </HStack>
            <VStack pl={6} spacing={1} align="start">
              <Text cursor="pointer" onClick={() => add("textHeadline")}>
                Headline
              </Text>
              <Text cursor="pointer" onClick={() => add("textBody")}>
                Body Copy
              </Text>
            </VStack>

            <HStack spacing={2}>
              <Icon as={FaBullhorn} boxSize={4} color="#FFF8" />
              <Text fontSize="xs" color="#FFF8" fontWeight="bold">
                EVENTS
              </Text>
            </HStack>
            <VStack pl={6} spacing={1} align="start">
              <Text cursor="pointer" onClick={() => add("event1col")}>
                1 Column
              </Text>
              <Text cursor="pointer" onClick={() => add("event2col")}>
                2 Column
              </Text>
              <Text cursor="pointer" onClick={() => add("eventList")}>
                Event List
              </Text>
            </VStack>

            <HStack spacing={2}>
              <Icon as={FaRegImage} boxSize={4} color="#FFF8" />
              <Text fontSize="xs" color="#FFF8" fontWeight="bold">
                MEDIA
              </Text>
            </HStack>
            <VStack pl={6} spacing={1} align="start">
              <Text cursor="pointer" onClick={() => add("image")}>
                Image
              </Text>
              <Text cursor="pointer" onClick={() => add("video")}>
                Video
              </Text>
            </VStack>

            <Text
              fontSize="lg"
              cursor="pointer"
              alignSelf="left"
              onClick={() => setShowMenu(false)}
            >
              ×
            </Text>
          </VStack>
        </Box>
      )}
    </>
  );
};

export default AddBlockToggle;
